import React from "react";
import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import type { ButtonProps } from "@mui/material";

interface PageRefreshButtonProps {
  loading?: boolean;
  onClick: ButtonProps["onClick"];
  disabled?: boolean;
  size?: ButtonProps["size"];
  label?: string;
  iconOnly?: boolean;
}

const PageRefreshButton: React.FC<PageRefreshButtonProps> = ({
  loading = false,
  onClick,
  disabled = false,
  size = "medium",
  label = "Refresh",
  iconOnly = false,
}) => iconOnly ? (
  <Tooltip title={label}><span><IconButton
    aria-label={label}
    onClick={onClick}
    disabled={loading || disabled}
    sx={{ width: 40, height: 40 }}
  >
    {loading ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon sx={{ fontSize: 20 }} />}
  </IconButton></span></Tooltip>
) : (
  <Button
    variant="outlined"
    startIcon={
      loading ? <CircularProgress size={size === "small" ? 16 : 18} color="inherit" /> : <RefreshIcon />
    }
    onClick={onClick}
    disabled={loading || disabled}
    size={size}
  >
    {label}
  </Button>
);

export default PageRefreshButton;
